export const PRIMARY_FONT = "'Public Sans', sans-serif";
export const SECONDARY_FONT = "'IBM Plex Mono', monospace";
export const Ubuntu = "'Ubuntu', sans-serif;";